import { defineStore } from "pinia"
import { ref } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export const useBackRouteStore = defineStore('backRoute', () => {
  const defaultBackRoute = { name: 'ConstructionList' }
  const backRoute = ref<RouteLocationRaw>(defaultBackRoute)

  const updateBackRoute = async (newBackRoute: RouteLocationRaw) => {
    backRoute.value = newBackRoute
  }
 
  const initBackRoute = async () => {
    backRoute.value = defaultBackRoute
  }

  return {
    backRoute,
    initBackRoute,
    updateBackRoute,
  }
})